import Main from '@/components/main'
import parentView from '@/components/parent-view'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面不会缓存
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [{
        path: '/login',
        name: 'login',
        meta: {
            title: 'Login - 登录',
            hideInMenu: true
        },
        component: () =>
            import ('@/view/login/login.vue')
    },

    {
        path: '/',
        name: '_home',
        redirect: '/agentManagement/agentList',
        component: Main,
        meta: {
            hideInMenu: true,
            notCache: true
        },
        children: [{
            path: '/home',
            name: 'home',
            meta: {
                hideInMenu: true,
                title: '首页',
                notCache: true,
                icon: 'md-home'
            },
            component: () =>
                import ('@/view/single-page/home')
        }]
    },
    {
        path: '/agentManagement',
        name: 'agentManagement',
        meta: {
            icon: 'md-pie',
            showAlways: true,
        },
        component: Main,
        children: [{
            path: 'agentList',
            name: 'agentList',
            meta: {
                title: '代理管理',
            },
            component: () =>
                import ('@/view/agentManagement/agentList.vue')
        }]
    },
    {
        path: '/schoolManagement',
        name: 'schoolManagement',
        meta: {
            icon: 'ios-school',
            showAlways: true,
        },
        component: Main,
        children: [{
                path: 'schoolList',
                name: 'schoolList',
                meta: {
                    title: '校区列表',
                },
                component: () =>
                    import ('@/view/schoolManagement/schoolList.vue')
            }, {
                path: 'teacherList',
                name: 'teacherList',
                meta: {
                    title: '老师列表',
                },
                component: () =>
                    import ('@/view/schoolManagement/teacherList.vue')
            }, {
                path: 'studentList',
                name: 'studentList',
                meta: {
                    title: '学生列表',
                },
                component: () =>
                    import ('@/view/schoolManagement/studentList.vue')
            }, {
                path: 'classList',
                name: 'classList',
                meta: {
                    title: '班级列表',
                },
                component: () =>
                    import ('@/view/schoolManagement/classList.vue')
            },
            {
                path: 'everydayStatistics',
                name: 'everydayStatistics',
                meta: {
                    title: '每日会员统计',
                },
                component: () =>
                    import ('@/view/schoolManagement/everydayStatistics.vue')
            },
            {
                path: 'rechargeList',
                name: 'rechargeList',
                meta: {
                    title: '充值记录',
                },
                component: () =>
                    import ('@/view/schoolManagement/rechargeList.vue')
            },

        ]
    },
    {
        path: '/appContent',
        name: 'appContent',
        meta: {
            icon: 'ios-appstore',
            showAlways: true
        },
        component: Main,
        children: [{
                path: 'courseCategory',
                name: 'courseCategory',
                meta: {
                    title: '课程类别管理'
                },
                component: () =>
                    import ('@/view/appContent/courseCategory.vue')
            },
            {
                path: 'courseMassage',
                name: 'courseMassage',
                meta: {
                    title: '课程信息管理'
                },
                component: () =>
                    import ('@/view/appContent/courseMassage.vue')
            },
            {
                path: 'studentCourseCatalogue',
                name: 'studentCourseCatalogue',
                meta: {
                    title: '学生课程目录管理'
                },
                component: () =>
                    import ('@/view/appContent/studentCourseCatalogue.vue')
            },
            {
                path: 'teacherCourseCatalogue',
                name: 'teacherCourseCatalogue',
                meta: {
                    title: '老师课程目录管理'
                },
                component: () =>
                    import ('@/view/appContent/teacherCourseCatalogue.vue')
            },
            {
                path: 'bannerList',
                name: 'bannerList',
                meta: {
                    title: 'banner管理'
                },
                component: () =>
                    import ('@/view/appContent/bannerList.vue')
            },
        ]
    },
    {
        path: '/videoManagement',
        name: 'videoManagement',
        meta: {
            icon: 'ios-videocam',
            showAlways: true
        },
        component: Main,
        children: [{
                path: 'videoType',
                name: 'videoType',
                meta: {
                    title: '视频类别管理'
                },
                component: () =>
                    import ('@/view/videoManagement/videoType.vue')
            }, {
                path: 'everydayList',
                name: 'everydayList',
                meta: {
                    title: '每日跟我弹列表'
                },
                component: () =>
                    import ('@/view/videoManagement/everydayList.vue')
            },
            {
                path: 'askMeAbout',
                name: 'askMeAbout',
                meta: {
                    title: '名师在线列表'
                },
                component: () =>
                    import ('@/view/videoManagement/askMeAbout.vue')
            },
            {
                path: 'teacherVideo',
                name: 'teacherVideo',
                meta: {
                    title: '老师视频管理'
                },
                component: () =>
                    import ('@/view/videoManagement/teacherVideo.vue')
            },
            {
                path: 'studentVideo',
                name: 'studentVideo',
                meta: {
                    title: '学生视频管理'
                },
                component: () =>
                    import ('@/view/videoManagement/studentVideo.vue')
            },
            {
                path: 'studentMien',
                name: 'studentMien',
                meta: {
                    title: '学生风采管理'
                },
                component: () =>
                    import ('@/view/videoManagement/studentMien.vue')
            },

        ]
    },
    {
        path: '/operationManagement',
        name: 'operationManagement',
        meta: {
            icon: 'ios-paper',
            showAlways: true
        },
        component: Main,
        children: [{
                path: 'orderList',
                name: 'orderList',
                meta: {
                    title: '学生会员订单管理'
                },
                component: () =>
                    import ('@/view/operationManagement/orderList.vue')
            },
            {
                path: 'schoolOrder',
                name: 'schoolOrder',
                meta: {
                    title: '校区订单管理'
                },
                component: () =>
                    import ('@/view/operationManagement/schoolOrder.vue')
            },

            {
                path: 'memberPricing',
                name: 'memberPricing',
                meta: {
                    title: '会员时长定价管理'
                },
                component: () =>
                    import ('@/view/operationManagement/memberPricing.vue')
            },
            {
                path: 'chargesSatistics',
                name: 'chargesSatistics',
                meta: {
                    title: '收费统计管理'
                },
                component: () =>
                    import ('@/view/operationManagement/chargesSatistics.vue')
            },
            {
                path: 'consultEnroll',
                name: 'consultEnroll',
                meta: {
                    title: '咨询报名管理'
                },
                component: () =>
                    import ('@/view/operationManagement/consultEnroll.vue')
            },

        ]
    },
    // {
    //     path: '/mallManagement',
    //     name: 'mallManagement',
    //     meta: {
    //         icon: 'md-cart',
    //         showAlways: true
    //     },
    //     component: Main,
    //     children: [{
    //             path: 'goodsManagement',
    //             name: 'goodsManagement',
    //             meta: {
    //                 title: '商品管理'
    //             },
    //             component: () =>
    //                 import ('@/view/mallManagement/goodsManagement.vue')
    //         },
    //         {
    //             path: 'goodsTypeManagement',
    //             name: 'goodsTypeManagement',
    //             meta: {
    //                 title: '商品分类管理'
    //             },
    //             component: () =>
    //                 import ('@/view/mallManagement/goodsTypeManagement.vue')
    //         },
    //         {
    //             path: 'goodsOrder',
    //             name: 'goodsOrder',
    //             meta: {
    //                 title: '商品订单管理'
    //             },
    //             component: () =>
    //                 import ('@/view/mallManagement/goodsOrder.vue')
    //         },


    //     ]
    // },
    {
        path: '/systemManagement',
        name: 'systemManagement',
        meta: {
            icon: 'ios-cog',
            showAlways: true
        },
        component: Main,
        children: [{
                path: 'adminList',
                name: 'adminList',
                meta: {
                    title: '系统账号管理'
                },
                component: () =>
                    import ('@/view/systemManagement/adminList.vue')
            },
            {
                path: 'roleList',
                name: 'roleList',
                meta: {
                    title: '角色管理'
                },
                component: () =>
                    import ('@/view/systemManagement/roleList.vue')
            },
            {
                path: 'editionManage',
                name: 'editionManage',
                meta: {
                    title: '版本管理'
                },
                component: () =>
                    import ('@/view/systemManagement/editionManage.vue')
            },


        ]
    },

    {
        path: '/401',
        name: 'error_401',
        meta: {
            hideInMenu: true
        },
        component: () =>
            import ('@/view/error-page/401.vue')
    },

    {
        path: '/500',
        name: 'error_500',
        meta: {
            hideInMenu: true
        },
        component: () =>
            import ('@/view/error-page/500.vue')
    },
    {
        path: '*',
        name: 'error_404',
        meta: {
            hideInMenu: true
        },
        component: () =>
            import ('@/view/error-page/404.vue')
    }
]